export default function initToggle() {
    const toggles = document.querySelectorAll('.block-toggle');

    toggles.forEach((toggle) => {
        const details = toggle.querySelector('.block-toggle__details');
        if (!details) return;

        const content = toggle.querySelector('.block-toggle__content');

        // Initial state check
        if (details.open) {
            content.style.maxHeight = 'none';
            content.style.opacity = '1';
        }

        // Handle toggle open/close with smooth animation (height + fade)
        details.addEventListener('toggle', (e) => {
            const content = toggle.querySelector('.block-toggle__content');
            
            if (e.target.open) {
                // Close all other toggles in the same group
                const parentContainer = toggle.closest('.block-toggle') ? toggle.parentElement : document;
                const allToggles = parentContainer.querySelectorAll('.block-toggle__details');
                
                allToggles.forEach((otherDetails) => {
                    if (otherDetails !== details && otherDetails.open) {
                        otherDetails.open = false;
                    }
                });

                // Opening
                content.style.maxHeight = 'none';
                const height = content.scrollHeight;
                content.style.maxHeight = '0';
                content.style.overflow = 'hidden';
                content.style.opacity = '0';
                
                // Trigger animation
                requestAnimationFrame(() => {
                    content.style.transition = 'max-height 0.3s ease-out, opacity 0.25s ease-out';
                    content.style.maxHeight = height + 'px';
                    content.style.opacity = '1';
                });

                setTimeout(() => {
                    content.style.maxHeight = 'none';
                    content.style.transition = '';
                }, 300);
            } else {
                // Closing
                content.style.maxHeight = content.scrollHeight + 'px';
                content.style.overflow = 'hidden';
                content.style.transition = 'max-height 0.3s ease-out, opacity 0.25s ease-out';
                content.style.opacity = '1';
                
                requestAnimationFrame(() => {
                    content.style.maxHeight = '0';
                    content.style.opacity = '0';
                });
            }
        });
    });
}
